// 미니게임 API 래퍼. 마이페이지 버튼 게이팅 + 게임 목록에서 사용.
// 실제 게임 플레이(iframe/세션/보상)는 게임 번들이 게임스코프 토큰으로 직접 호출한다(G3).

import type { GameConfigDto } from "@oo/shared";
import { api } from "@/api/client.ts";

// 게임 활성 여부/보상 안내. 마이페이지에서 버튼 노출을 결정한다.
export async function getGameConfig(): Promise<GameConfigDto> {
  const data = await api.get<{ config: GameConfigDto }>("/games/config");
  return data.config;
}

// 게임 iframe/캔버스가 쓸 단명 게임스코프 토큰 발급(사용자 세션 인증).
//  - 게임 코드는 사용자 토큰을 보지 않고 이 토큰으로만 /games/* 를 호출한다.
export async function mintGameToken(): Promise<string> {
  const data = await api.post<{ token: string; expiresAtSec: number }>("/games/session/token");
  return data.token;
}
